// CheckboxDropdown.js
import React, { useState, useRef, useEffect } from 'react';
import './CheckboxDropdown.css'; // CSS 파일을 임포트합니다.

const CheckboxDropdown = ({ options, initialSelected = [], onSelectionChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  // Set을 사용하여 선택된 항목을 효율적으로 관리 (중복 방지, 빠른 검색)
  const [selectedItems, setSelectedItems] = useState(new Set(initialSelected));
  const dropdownRef = useRef(null); // 드롭다운 외부 클릭 감지를 위한 ref

  // 컴포넌트 마운트 시 또는 initialSelected가 변경될 때 Set 초기화
  useEffect(() => {
    setSelectedItems(new Set(initialSelected));
  }, [initialSelected]);

  // 외부 클릭 감지 로직
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (option) => {
    const newSelectedItems = new Set(selectedItems);
    if (newSelectedItems.has(option)) {
      newSelectedItems.delete(option);
    } else {
      newSelectedItems.add(option);
    }
    setSelectedItems(newSelectedItems);
    // 부모 컴포넌트로 선택된 항목들을 배열 형태로 전달
    onSelectionChange(Array.from(newSelectedItems));
  };

  // 드롭다운 버튼에 표시될 텍스트
  const getButtonText = () => {
    if (selectedItems.size === 0) {
      return 'Tokenizer Selection';
    } else if (selectedItems.size === options.length) {
      return 'All tokenizers selected';
    } else {
      // 선택된 항목이 많을 경우 "N개 선택됨"으로 표시
      if (selectedItems.size > 2) { // 2개 초과 선택 시 "N개 선택됨"으로 표시
        return `${selectedItems.size} items selected`;
      }
      // 선택된 항목이 적을 경우 항목 이름 표시
      return Array.from(selectedItems).join(', ');
    }
  };

  return (
    <div className="checkbox-dropdown-container" ref={dropdownRef}>
      <button className="dropdown-toggle" onClick={handleToggle}>
        {getButtonText()}
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          {options.map((option) => (
            <label key={option} className="dropdown-item">
              <input
                type="checkbox"
                value={option}
                checked={selectedItems.has(option)}
                onChange={() => handleCheckboxChange(option)}
              />
              {option}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default CheckboxDropdown;